/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ per: NonNullable<unknown> }} Measure_Explainer_Title_ReturnedInputs */

const en_measure_explainer_title_returned = /** @type {(inputs: Measure_Explainer_Title_ReturnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Metered ${i?.per} returned`)
};

const zh_hans1_measure_explainer_title_returned = /** @type {(inputs: Measure_Explainer_Title_ReturnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`计量方式：${i?.per}，按实际返回`)
};

const pt_br2_measure_explainer_title_returned = /** @type {(inputs: Measure_Explainer_Title_ReturnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cobrado ${i?.per} retornado`)
};

const es_measure_explainer_title_returned = /** @type {(inputs: Measure_Explainer_Title_ReturnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cobro ${i?.per} devuelto`)
};

const fr_measure_explainer_title_returned = /** @type {(inputs: Measure_Explainer_Title_ReturnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Facturé ${i?.per} renvoyé`)
};

const de_measure_explainer_title_returned = /** @type {(inputs: Measure_Explainer_Title_ReturnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abgerechnet ${i?.per}, nur gelieferte Daten`)
};

const ru_measure_explainer_title_returned = /** @type {(inputs: Measure_Explainer_Title_ReturnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Тарификация ${i?.per}: возвращено`)
};

const it_measure_explainer_title_returned = /** @type {(inputs: Measure_Explainer_Title_ReturnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Calcolato ${i?.per} restituito`)
};

/**
* | output |
* | --- |
* | "Metered {per} returned" |
*
* @param {Measure_Explainer_Title_ReturnedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_explainer_title_returned = /** @type {((inputs: Measure_Explainer_Title_ReturnedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Explainer_Title_ReturnedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_explainer_title_returned(inputs)
	if (locale === "pt-BR") return pt_br2_measure_explainer_title_returned(inputs)
	if (locale === "es") return es_measure_explainer_title_returned(inputs)
	if (locale === "fr") return fr_measure_explainer_title_returned(inputs)
	if (locale === "de") return de_measure_explainer_title_returned(inputs)
	if (locale === "ru") return ru_measure_explainer_title_returned(inputs)
	if (locale === "it") return it_measure_explainer_title_returned(inputs)
	return en_measure_explainer_title_returned(inputs)
});